import React from 'react';
import {HTMLContent, contentUtils} from "mindsets-js-sdk";

import BaseAnswer from '../BaseAnswer';
import NumberOnlyField from './NumberOnlyField';


export default class NumberOnly extends BaseAnswer {
    defaultAnswer() {
        const items = _.get(this.props.component_data, 'data.items');
        const inputItems = _.filter(items, {type: 'input'});
        const answer_selections = _.fill(Array(inputItems.length), '');
        return {
            text: '',
            answer_selections
        }
    }

    isValid() {
        const items = _.get(this.props.component_data, 'data.items');
        const inputItems = _.filter(items, {type: 'input'});
        const answer_selections = [];
        if (answer_selections.length < inputItems.length) {
            return false;
        }
        const emptyOnes = _.filter(answer_selections, (v) => !v || v === '');
        if (emptyOnes.length > 0) {
            return false;
        }
        return true;
    }

    onChange(inputKey) {
        return e => {
            e.preventDefault();
            const regex = /^[0-9.+-]*$/;
            const v = e.target.value;
            if (v.match(regex)) {
                const newAnswerSelections = [];
                _.set(newAnswerSelections, inputKey, v);
                const newText = this.getAnswerText(newAnswerSelections);
                const newAnswer = {
                    text: newText,
                    answer_selections: newAnswerSelections
                }
                this.setState({answer: newAnswer});

                // console.log('answer', newAnswer);
            }
        }
    }
    
    getAnswerText(answer_selections) {
        const isNotEmpty = !!_.find(answer_selections, (v) => !!v);
        if (!isNotEmpty) {
            return '';
        }

        const items = _.get(this.props.component_data, 'data.items', []);
        let inputKey = -1;
        const textArray = items.map((item) => {
            if (item.type === 'input') {
                inputKey++;
                return _.get(answer_selections, inputKey, '');
            } else {
                return _.get(item, 'content.text');
            }
        })
        return textArray.join('');
    }

    renderItem(itemData, inputKey) {
        switch (itemData.type) {
            case 'hidden':
                return null;
            case 'static':
                const content = _.get(itemData, 'content.html');
                return (
                    <div className="cc-numberonly-item-static" style={itemData.style}>
                        <HTMLContent html_str={contentUtils.processStringContent(content)}/>
                    </div>
                );
            case 'input':
                return (
                    <NumberOnlyField
                        component_data={this.props.component_data}
                        is_preview={this.props.is_preview}
                        answer={{
                            text: '',
                            answer_selections: []
                        }}
                        existing_answer={this.props.existing_answer}
                        onChange={this.onChange(inputKey)}
                        itemData={itemData}
                        inputKey={inputKey}
                    />
                );
            default:
                return null;
        }
    }

    renderAllItems() {
        const items = _.get(this.props.component_data, 'data.items', []);
        let inputKey = -1;
        return items.map((itemData, itemKey) => {
            if (itemData.type === 'input') {
                inputKey++;
            }
            return (
                <div key={itemKey}>
                    {this.renderItem(itemData, inputKey)}
                </div>
            );
        });
    }

    render() {
        return (
            <div className="challenge-component-numberonly">
                <div className="cc-numberonly-description">
                    {`Enter a number in each box below.`}
                </div>

                <div className="d-flex flex-wrap align-items-center">
                    {this.renderAllItems()}
                </div>
            </div>
        )
    }
}
